import styles from "./styles/FestivalManager.module.css";
import React, { useEffect, useState } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { CalendarOutlined } from "@ant-design/icons";
// import TemplatesGrid from "./TemplatesGrid";
import FestivalImageGenerator from "./FestivalImageGenerator";
import useMedia from "react-use/lib/useMedia";
import {
    Button,
    Checkbox,
    DatePicker,
    Form,
    Input,
    Modal,
    Pagination,
    Rate,
    Segmented,
    Select,
    Spin,
    Table,
} from "antd";
import {
    useCreateItemMutation,
    useItemsFine,
    useUpdateItemMutation,
} from "../actions/app/items";
import { getImageFileURL, getPublicImageURL } from "../_helpers/image";
import { parseDate } from "../_helpers/app/dt";
import RelationField from "../qforms/elements/RelationField";
import RelationFieldStanard from "../qforms/standard_elements/RelationFieldStandard";
import { PlusOutlined } from "@ant-design/icons";
import { useDebounce } from "../utils/input";
import { snakeCase } from "lodash";
import log from "cslog";
import { PreviewTemplateList } from "../qmade/creator/PreviewTemplateList";
import dayjs from "dayjs";

const per_page = 20;

function FestivalManager({ me }) {
    const isMobile = useMedia("(max-width: 700px)");

    const [total, setTotal] = useState(1);
    const [num_page, setNumPage] = useState(1);
    const [page_no, setPageNo] = useState(1);

    const [sort, setSort] = useState("date");
    const [searchQuery, setSearchQuery] = useState("");
    const [filterOutdated, setFilterOutdated] = useState(false); // new state

    const { isSuccess, isLoading, data } = useItemsFine(
        "qdb_event",
        `filter[event_type][_eq]=festival&fields=*,primary_tag.*&sort=${sort}&meta=*&limit=${per_page}&offset=${
            per_page * (page_no - 1)
        }${searchQuery ? `&filter[name][_contains]=${searchQuery}` : ""}${
            filterOutdated
                ? `&filter[same_every_year][_eq]=false&filter[date][_lt]=${dayjs().format(
                      "YYYY-MM-DD"
                  )}`
                : ""
        }`,
        true,
        false,
        true
    );
    const [tag_list, setTagList] = useState([]);
    const [templates_count, setTemplatesCount] = useState({});
    const { isSuccess: successTemplates, data: dataTemplates } = useItemsFine(
        "qdb_creation_template",
        `fields=id,title,primary_tags.qdb_tag_id&filter[primary_tags][qdb_tag_id][_in]=${tag_list.join(
            ","
        )}`,
        tag_list.length > 0,
        false,
        false
    );

    const mutationUpdate = useUpdateItemMutation(
        () => {},
        () => {},
        () => {}
    );
    const [selected_festival, setSelectedFestival] = useState(null);

    useEffect(() => {
        setPageNo(1);
    }, [searchQuery]);

    useEffect(() => {
        if (successTemplates && dataTemplates) {
            const out = {};
            dataTemplates?.forEach((item) => {
                const tag_id = item?.primary_tags?.[0]?.qdb_tag_id;
                if (tag_id) {
                    const current_count = out[tag_id] ?? 0;
                    out[tag_id] = current_count + 1;
                }
            });
            setTemplatesCount(out);
        }
    }, [successTemplates, dataTemplates]);

    log.d(dataTemplates, "dataTemplates");

    useEffect(() => {
        if (isSuccess) {
            console.log("response festival", data);
            const total_records = data?.meta?.filter_count;
            if (total_records > 0) {
                setTotal(total_records);
                setNumPage(Math.ceil(total_records / per_page));
            }

            setTagList(data?.data?.map((item) => item.primary_tag?.id));
        }
    }, [isSuccess, data]);

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Festival Manager"
                    icon={<CalendarOutlined />}
                >
                    <Segmented
                        options={["All", "Outdated"]}
                        value={filterOutdated ? "Outdated" : "All"}
                        onChange={(val) =>
                            setFilterOutdated(val === "Outdated")
                        }
                    />
                    <Input.Search
                        placeholder="Search festitvals by name"
                        allowClear
                        onSearch={(value) => setSearchQuery(value)}
                        style={{ width: 250 }}
                    />
                    <AddFestivalModal
                        trigger={
                            <Button type="primary" icon={<PlusOutlined />}>
                                Add Festival
                            </Button>
                        }
                    />
                </SectionHeader>
            }
        >
            <div className={styles.wrapper}>
                {/* {templates_count && <pre>{JSON.stringify(templates_count, null, 2)}</pre>}
            {tag_list.length > 0 && <pre>{JSON.stringify(tag_list, null, 2)}</pre>} */}
                {isSuccess && (
                    <Table
                        size="small"
                        columns={[
                            {
                                title: "Date",
                                dataIndex: "date",
                                key: "date",
                                sorter: true,
                                // render: item => <code>{parseDate(item).format("DD-MMM-YYYY")}</code>
                                render: (item, record) => {
                                    return (
                                        <DatePicker
                                            value={item ? parseDate(item) : ""}
                                            onChange={(new_val) => {
                                                mutationUpdate.mutate({
                                                    collection: "qdb_event",
                                                    id: record.id,
                                                    data: {
                                                        date: new_val,
                                                    },
                                                });
                                            }}
                                            style={{ width: "150px" }}
                                            loading={mutationUpdate.isLoading}
                                        />
                                    );
                                },
                            },
                            {
                                title: "Name",
                                dataIndex: "name",
                                key: "name",
                                sorter: true,
                            },
                            {
                                title: "Primary Tag",
                                dataIndex: "primary_tag",
                                key: "primary_tag",
                                render: (item, record) => {
                                    if (!item?.name) {
                                        return (
                                            <PrimaryTagField
                                                onChange={(val) => {
                                                    mutationUpdate.mutate({
                                                        collection: "qdb_event",
                                                        id: record.id,
                                                        data: {
                                                            primary_tag: val,
                                                        },
                                                    });
                                                }}
                                            />
                                        );
                                    }
                                    return (
                                        <span
                                            style={{
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {item?.name}
                                        </span>
                                    );
                                },
                            },
                            {
                                title: "Star",
                                dataIndex: "star",
                                key: "star",
                                sorter: true,
                                render: (item, record) => {
                                    return (
                                        <div className={styles.flex_h_center}>
                                            <Rate
                                                count={5}
                                                value={item}
                                                disabled={
                                                    mutationUpdate.isLoading
                                                }
                                                onChange={(val) => {
                                                    mutationUpdate.mutate({
                                                        collection: "qdb_event",
                                                        id: record.id,
                                                        data: {
                                                            star: val,
                                                        },
                                                    });
                                                }}
                                                style={{
                                                    width: "150px",
                                                }}
                                            />
                                            {mutationUpdate.isLoading && (
                                                <Spin />
                                            )}
                                        </div>
                                    );
                                },
                            },
                            {
                                title: "Feature Image",
                                dataIndex: "feature_image",
                                key: "feature_image",
                                render: (item, record) =>
                                    item ? (
                                        <img
                                            src={getPublicImageURL(item)}
                                            alt={record.name}
                                            style={{
                                                width: "70px",
                                                height: "50px",
                                                objectFit: "cover",
                                                margin: "-10px",
                                            }}
                                        />
                                    ) : (
                                        <FestivalImageGenerator
                                            festival={record}
                                        />
                                    ),
                            },
                            // {
                            //     title: "Templates",
                            //     dataIndex: "templates",
                            //     key: "templates",
                            //     render: (item, record) => {
                            //         return <div className={styles.flex_h_center}>
                            //             {templates_count[record.primary_tag?.id] ?? "-"}
                            //         </div>
                            //     }
                            // },
                            {
                                title: "Actions",
                                dataIndex: "actions",
                                key: "actions",
                                render: (item, record) => {
                                    return (
                                        <div className={styles.flex_h_center}>
                                            <Button
                                                onClick={() => {
                                                    setSelectedFestival(record);
                                                }}
                                            >
                                                Preview (
                                                {templates_count[
                                                    record.primary_tag?.id
                                                ] ?? "-"}
                                                )
                                            </Button>
                                        </div>
                                    );
                                },
                            },
                        ]}
                        rowKey="id"
                        bordered={true}
                        dataSource={data?.data}
                        pagination={false}
                        onChange={(pagination, filter, sorter) => {
                            console.log(sorter);
                            if (sorter?.field && sorter?.order) {
                                setSort(
                                    `${sorter.order === "ascend" ? "-" : ""}${
                                        sorter.field
                                    }`
                                );
                            }
                        }}
                    />
                )}
                <div style={{ height: 20 }}></div>
                {isSuccess && total > per_page && (
                    <Pagination
                        current={page_no}
                        onChange={(new_page_no) => setPageNo(new_page_no)}
                        total={total}
                        pageSize={per_page}
                        showTitle={false}
                        showSizeChanger={false}
                        showQuickJumper={true}
                    />
                )}
            </div>

            {selected_festival && (
                <PreviewTemplateList
                    me={me}
                    open={selected_festival !== null}
                    setOpen={() => {
                        setSelectedFestival(null);
                    }}
                    enable={selected_festival !== null}
                    filter={`{"primary_tags": { "qdb_tag_id": { "_eq": "${selected_festival?.primary_tag?.id}" } } }`}
                />
            )}
        </QurealSection>
    );
}

export default FestivalManager;

function PrimaryTagField({ value, onChange }) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
            }}
        >
            <PrimaryTagModal
                value={value}
                onChange={onChange}
                trigger={<Button icon={<PlusOutlined />}>Add </Button>}
            />
        </div>
    );
}

function PrimaryTagModal({ trigger, value, onChange }) {
    const [open, setOpen] = useState(false);
    const [search_term, setSearchTerm] = useState("");
    const debounced_query = useDebounce(search_term, 500);
    const { isLoading, isSuccess, data, refetch } = useItemsFine(
        "qdb_tag",
        `fields=id,name,type&filter[name][_contains]=${debounced_query}&limit=-1`,
        debounced_query?.length > 2,
        false,
        false
    );
    const [selected_tag, setSelectedTag] = useState(null);
    const updateMutation = useUpdateItemMutation(
        () => {
            refetch();
        },
        () => {},
        () => {}
    );
    const createMutation = useCreateItemMutation(
        () => {
            refetch();
        },
        () => {},
        () => {}
    );

    useEffect(() => {
        if (isSuccess && selected_tag) {
            const updated_tag = data.find(
                (item) => item.id === selected_tag.id
            );
            setSelectedTag(updated_tag);
        }
    }, [data, isLoading, isSuccess]);

    return (
        <>
            <div onClick={() => setOpen(true)}>{trigger}</div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                title="Add Primary Tag"
                footer={[
                    <Button onClick={() => setOpen(false)}>Cancel</Button>,
                    <Button
                        type="primary"
                        loading={updateMutation.isLoading}
                        disabled={selected_tag?.type !== "primary"}
                        onClick={() => {
                            if (selected_tag?.type === "primary") {
                                onChange(selected_tag?.id);
                                setOpen(false);
                            }
                        }}
                    >
                        Save
                    </Button>,
                ]}
            >
                <Select
                    style={{ width: "300px" }}
                    filterOption={false}
                    showSearch={true}
                    onSearch={(val) => setSearchTerm(val)}
                    notFoundContent={
                        isLoading ? (
                            <Spin size="small" />
                        ) : (
                            <Button
                                isLoading={createMutation.isLoading}
                                onClick={() => {
                                    createMutation.mutate({
                                        collection: "qdb_tag",
                                        data: {
                                            name: snakeCase(search_term),
                                            type: "primary",
                                        },
                                    });
                                }}
                            >
                                Create Tag
                            </Button>
                        )
                    }
                    options={data?.map((item) => ({
                        label: item.name,
                        key: item.id,
                        value: item.id,
                    }))}
                    onChange={(val) => {
                        const tag = data.find((item) => item.id === val);
                        setSelectedTag(tag);
                    }}
                />

                {selected_tag && (
                    <>
                        {selected_tag?.type === "primary" ? (
                            <div>
                                <p>Selected tag is a primary tag.</p>
                            </div>
                        ) : (
                            <div>
                                <p>Selected tag is not primary tag</p>
                                <Button
                                    onClick={() => {
                                        if (selected_tag?.type !== "primary") {
                                            updateMutation.mutate({
                                                collection: "qdb_tag",
                                                id: selected_tag?.id,
                                                data: {
                                                    type: "primary",
                                                },
                                            });
                                        }
                                    }}
                                    loading={updateMutation.isLoading}
                                >
                                    Make primary
                                </Button>
                            </div>
                        )}
                    </>
                )}

                {/* <pre>{JSON.stringify(selected_tag, null, 2)}</pre> */}
            </Modal>
        </>
    );
}

function AddFestivalModal({ trigger }) {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const mutation_create = useCreateItemMutation(
        () => {
            form.resetFields();
            setOpen(false);
        },
        () => {},
        () => {}
    );
    const [same_every_year, setSameEveryYear] = useState(false);

    return (
        <>
            <div onClick={() => setOpen(true)}>{trigger}</div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                title="Add Festival"
                footer={[
                    <Button onClick={() => setOpen(false)}>Cancel</Button>,
                    <Button
                        type="primary"
                        loading={mutation_create.isLoading}
                        onClick={() => {
                            form.submit();
                        }}
                    >
                        Save
                    </Button>,
                ]}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={(values) => {
                        // setOpen(false);
                        log.d(values, "Values");
                        mutation_create.mutate({
                            collection: "qdb_event",
                            data: {
                                ...values,
                                status: "published",
                                same_every_year: !!same_every_year,
                            },
                        });
                    }}
                >
                    <Form.Item label="Name" name="name">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Date" name="date">
                        <DatePicker />
                    </Form.Item>
                    <Form.Item label="Primary Tag" name="primary_tag">
                        <PrimaryTagModal
                            trigger={<Button>Primary Tag</Button>}
                        />
                    </Form.Item>
                    <Form.Item label="Stars" name="star">
                        <Rate count={5} />
                    </Form.Item>
                    <Form.Item label="Same every year" name="same_every_year">
                        <Checkbox
                            checked={same_every_year}
                            onChange={(e) => setSameEveryYear(e.target.checked)}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}
